import { Grid, TextField } from "@mui/material"
import { permitirApenasNumeros } from "../../../../../../../../../../helpers/masks"
import { IInternForm } from "./DialogCadastrarPag"
export default function CartaoForm({
    values,
    handleChangeValues
}: CartaoFormProps) {

    //querys e mutations
    //

    //funçoes manipuladoras
    //


    return (
        <Grid container size={{xs: 12}} spacing={2}>
            <Grid size={{xs: 12, md: 6}}>
                <TextField
                    fullWidth
                    label='Nsu'
                    type="text"
                    value={values.cartao_nsu || ''}
                    onChange={(e) => {
                        const format = permitirApenasNumeros(e.target.value)
                        handleChangeValues("cartao_nsu", format)
                    }}
                />
            </Grid>

            <Grid size={{xs: 12, md: 6}}>
                <TextField
                    fullWidth
                    label='Autorização'
                    type="text"
                    value={values.cartao_autorizacao || ''}
                    onChange={(e) => handleChangeValues("cartao_autorizacao", e.target.value)}
                />
            </Grid>
        </Grid>
    )
}

interface CartaoFormProps {
    values: IInternForm,
    handleChangeValues: (prop: keyof IInternForm, value: any) => void
}